import { Star } from "lucide-react";

export function Stars({ value = 0, size = "w-4 h-4", onChange, testId = "stars" }) {
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!onChange}
          onClick={() => onChange?.(n)}
          data-testid={onChange ? `${testId}-${n}` : undefined}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          className={`${onChange ? "cursor-pointer hover:scale-110" : "cursor-default"} transition-transform`}
        >
          <Star className={`${size} ${n <= Math.round(value) ? "fill-[#d4af37] text-[#d4af37]" : "text-[#cfcfcf]"}`} />
        </button>
      ))}
    </div>
  );
}
